import Vue from "vue";
import router from "../router";
import { CommonIn, SortSelector, PageIn } from "@/pbjs/xcommon/common_pb";
import { localGet } from "@/utils/index";
//  处理错误提示
function errorMsg(err: any) {
  if (err.code) {
    if (err.code == 16) {
      router.push("./login");
    } else {
      Vue.prototype.$message({
        message: err.errmsg ? err.errmsg : err.message,
        type: "error"
      });
    }
  } else {
    Vue.prototype.$message({
      message: err.errmsg ? err.errmsg : err.message,
      type: "error"
    });
  }
}
//  统一处理数据请求的返回
function handleResponse(res: any, fuc?: any): any {
  console.log(res,'----responseData-----')
  if (res.commonout) {
    let _data = res.commonout;
    if (_data.code == 0) {
      res.right = true;
      return fuc ? fuc(res) : res;
    } else if (_data.code == 100100 || _data.code == 100101) {
      Vue.prototype.$selfRouter.push("./login");
    } else {
      res.right = false;
      Vue.prototype.$message({
        message: _data.errmsg,
        type: "error"
      });
      // return fuc ? fuc(res) : res;
    }
  } else {
    if (!res.code || res.code == 0) {
      return fuc ? fuc(res) : res;
    } else if (res.code == 100100 || res.code == 100101) {
      Vue.prototype.$selfRouter.push("./login");
    } else if (res.code == 100115) {
      return fuc ? fuc(res) : res;
    } else {
      Vue.prototype.$message({
        message: res.errmsg ? res.errmsg : res.message,
        type: "error"
      });
      return fuc ? fuc(res) : res;
    }
  }
}
function returnResponse(res: any): any {
  return res;
}
//  配置公共请求体
function setCommon() {
  const common = new CommonIn();
  common.setTrackid("");
  common.setClientid("");
  common.setLang(localGet("cn") ? localGet("cn") : "zh-CN");
  common.setToken(localGet("token"));
  common.setUserid(Number(localGet("userid")));
  return common;
}
//  配置公共分页数据请求体（包含分页条目、页数、排序方式、排序顺序）
function setPage(
  page: number,
  pageSize: number,
  sort: any = "",
  rank: any = ""
) {
  const pageInfo = new PageIn();
  pageInfo.setPage(page);
  pageInfo.setPagesize(pageSize);
  if (sort && rank) {
    const sorter = new SortSelector();
    sorter.setSort(sort);
    sorter.setRank(rank);
    pageInfo.setSorter(sorter);
  } else {
    const sorter = new SortSelector();
    if (sort) {
      sorter.setSort(sort);
    }
    if (rank) {
      sorter.setRank(rank);
    }
    pageInfo.setSorter(sorter);
  }
  return pageInfo;
}

export { errorMsg, handleResponse, returnResponse, setCommon, setPage };
